import defineAbilityFor from '@/resources/ability';
import { PortalClienteResource } from '@/resources/role';

var AbilitiesMixin = {
  methods: {
    // Para chequear permisos generales, cuando no hay que comprobar por ejemplo si alguien tiene asignada una reclamacion 
    checkAbility(permision) {
      return defineAbilityFor(this.$store.state.profile).can(permision, PortalClienteResource);
    },
    // Para chequear permisos concretos, por ejemplo que la reclamacion no tiene agente asignado para poder asignarsela. 
    checkAbilityWithEntity(permision, entity) {
      return defineAbilityFor(this.$store.state.profile).can(permision, entity);
    },
  }
};
export default AbilitiesMixin;